import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { compose } from 'recompose';
import {withAuthorization} from './utils/auth';
import { Layout, Menu, Icon, Card, Row, Col } from 'antd';
import {NavLink, withRouter} from 'react-router-dom';
import moment from 'moment';

@observer
class Overview extends Component {
  constructor(props) {
    super(props);
    this.getPendingNurses = this.getPendingNurses.bind(this);
    this.props.userStore.pendingNurses.query = this.props.userStore.pendingNurses.ref.where('role', '==', 'nurse').where('isNurseValidated', '==', false).orderBy('createTime');
    this.props.userStore.Patients.query = this.props.userStore.Patients.ref.where('role', '==', 'patient').where('createTime', '>=', moment().subtract(24, 'hours').toDate()).orderBy('createTime', "desc")
  }
  getPendingNurses() {
    this.props.userStore.users.query = this.props.userStore.users.ref.where('role', '==', 'nurse').where('isNurseValidated', '==', false).orderBy('createTime');
  }
  render() {

    return (
      <div>
        <h1>Dashboard</h1>
          <div>
            <Row gutter={24}>
              <Col span={12}>
                <Card title={"Intervenants à Valider ("+ this.props.userStore.pendingNurses.docs.length + ")"}
                  extra={<NavLink onClick={this.getPendingNurses} to={{pathname: '/users', data: {fireStoreQuery: true} }}
                      >
                      Voir plus
                    </NavLink>}>
                  {this.props.userStore.pendingNurses.docs.map((user, i) => (
                    <p key={i}><NavLink to={{pathname: `/users/${user.id}`, data: {user:user.doc}}}>{user.data.email}</NavLink></p>
                  ))}
                </Card>
              </Col>
              <Col span={12}>
                <Card title={"Nouveaux Utilisateurs (" + this.props.userStore.Patients.docs.length + ")"} extra={<NavLink to={'/users'}>Voir plus</NavLink>} >
                  {this.props.userStore.Patients.docs.map((user, i) => {
                    if(i<10) {
                      return <p key={i}><NavLink to={{pathname: `/users/${user.id}`, data: {user:user.doc}}}>{user.data.email}</NavLink></p>
                    }
                  })}
                </Card>
              </Col>
            </Row>
        </div>
      </div>
    )
  }
}

const authCondition = (authUser) => !!authUser;

export default compose(
  withAuthorization(authCondition),
  inject('userStore'),
  withRouter,
  observer
)(Overview);



// WEBPACK FOOTER //
// ./src/Overview.js